import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import AnimateHeight from "react-animate-height";
import { AfricaMap } from "../../AfricaMap/AfricaMap";
import { AsiaMap } from "../../AsiaMap/AsiaMap";
import styles from "./ResultsOutputMaps.module.scss";
import { stegaClean } from "@sanity/client/stega";
export const ResultsOutputMaps: React.FC<{
  outputCountries: string[];
  locale?: string;
}> = t0 => {
  const $ = _c(27);
  const {
    outputCountries,
    locale
  } = t0;
  const [activeMap, setActiveMap] = useState(0);
  const [mapHeight, setMapHeight] = useState(0);
  const [hoveredCountry, setHoveredCountry] = useState(null);
  const mapWrapperRef = useRef(null);
  let maps;
  if ($[0] !== locale || $[1] !== outputCountries) {
    maps = [];
    if (outputCountries) {
      for (const country of outputCountries.map(stegaClean)) {
        if (AsiaSet.has(country)) {
          if (maps.some(_temp)) {
            continue;
          }
          maps.push({
            name: "Asia",
            component: <AsiaMap highlightedCountries={outputCountries.filter(_temp2)} setHoveredCountry={setHoveredCountry} locale={locale} />
          });
        } else {
          if (AfricaSet.has(country)) {
            if (maps.some(_temp3)) {
              continue;
            }
            maps.push({
              name: "Afrika",
              component: <AfricaMap highlightedCountries={outputCountries.filter(_temp4)} setHoveredCountry={setHoveredCountry} locale={locale} />
            });
          }
        }
      }
    }
    $[0] = locale;
    $[1] = outputCountries;
    $[2] = maps;
  } else {
    maps = $[2];
  }
  const maps_0 = maps;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (mapWrapperRef.current) {
        setMapHeight(mapWrapperRef.current.querySelector(`.${styles.activeMap}`)?.clientHeight || 0);
      }
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== activeMap) {
    t2 = [activeMap];
    $[4] = activeMap;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== hoveredCountry) {
    t3 = hoveredCountry && <div className={styles.hoveredCountry} style={{
      left: hoveredCountry.x,
      top: hoveredCountry.y
    }}>{hoveredCountry.name}</div>;
    $[6] = hoveredCountry;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = mapHeight || "auto";
  let t5;
  if ($[8] !== activeMap || $[9] !== maps_0) {
    t5 = activeMap !== maps_0.length - 1 && <button className={styles.nextMap} onClick={() => setActiveMap(activeMap + 1)}>{maps_0[activeMap + 1].name} →</button>;
    $[8] = activeMap;
    $[9] = maps_0;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== activeMap || $[12] !== maps_0) {
    t6 = activeMap !== 0 && <button className={styles.prevMap} onClick={() => setActiveMap(activeMap - 1)}>← {maps_0[activeMap - 1].name}</button>;
    $[11] = activeMap;
    $[12] = maps_0;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== activeMap || $[15] !== maps_0) {
    t7 = <div className={styles.mapsTrack}>{maps_0.map((map, i) => <div key={map.name} className={styles.map + " " + (activeMap === i ? styles.activeMap : "")}>{map.component}</div>)}</div>;
    $[14] = activeMap;
    $[15] = maps_0;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className={styles.mapsContainer}>{t5}{t6}{t7}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t4 || $[22] !== t8) {
    t9 = <AnimateHeight height={t4} animateOpacity={true}>{t8}</AnimateHeight>;
    $[21] = t4;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t3 || $[25] !== t9) {
    t10 = <div className={styles.mapWrapper} ref={mapWrapperRef}>{t3}{t9}</div>;
    $[24] = t3;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};
const AsiaSet = new Set(["af", "am", "az", "bh", "bd", "bt", "bn", "kh", "cn", "cy", "ge", "in", "id", "ir", "iq", "il", "jp", "jo", "kz", "kp", "kr", "kw", "kg", "la", "lb", "my", "mv", "mn", "mm", "np", "om", "pk", "ps", "ph", "qa", "sa", "sg", "lk", "sy", "tw", "tj", "th", "tl", "tr", "tm", "ae", "uz", "vn", "ye"]);
const AfricaSet = new Set(["dz", "ao", "bj", "bw", "bf", "bi", "cv", "cm", "cf", "td", "km", "cd", "cg", "ci", "dj", "eg", "gq", "er", "sz", "et", "ga", "gm", "gh", "gn", "gw", "ke", "ls", "lr", "ly", "mg", "mw", "ml", "mr", "mu", "yt", "ma", "mz", "na", "ne", "ng", "re", "rw", "sh", "st", "sn", "sc", "sl", "so", "za", "ss", "sd", "tz", "tg", "tn", "ug", "eh", "zm", "zw"]);
function _temp(m) {
  return stegaClean(m.name) === "Asia";
}
function _temp2(c) {
  return AsiaSet.has(stegaClean(c));
}
function _temp3(m_0) {
  return stegaClean(m_0.name) === "Afrika";
}
function _temp4(c_0) {
  return AfricaSet.has(stegaClean(c_0));
}